import * as React from "react";
import { withLocalization } from "@shared-ui/localization-context";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "src/components/flexFramework/domain/BlossomComponentFactory";
import { AuthenticationState } from "bernie-context";
import { AuthContainerProps } from "./typings";

enum AuthContainerOptions {
  ANONYMOUS = "ANONYMOUS",
  IDENTIFIED = "IDENTIFIED",
  AUTHENTICATED = "AUTHENTICATED",
  IDENTIFIED_AUTHENTICATED = "IDENTIFIED_AUTHENTICATED",
}

@withLocalization
export class AuthContainer extends React.Component<AuthContainerProps> {
  public isIdentifiedAuthenticated = (currentAuth: string, authLevel: string): boolean =>
    authLevel === AuthContainerOptions.IDENTIFIED_AUTHENTICATED &&
    (currentAuth === AuthenticationState.IDENTIFIED || currentAuth === AuthenticationState.AUTHENTICATED);

  public render() {
    const { flexComponent, context, logger, l10n } = this.props;
    const { authLevel } = flexComponent.model;
    const blossomComponent = BlossomComponentFactory.get(this.props as BlossomComponentFactoryProps);
    const currentAuth: string = context?.user.authState;
    const extendedMatch = this.isIdentifiedAuthenticated(currentAuth, authLevel);
    const authMatch: boolean = extendedMatch || currentAuth === authLevel;

    if (!authMatch || !blossomComponent || !blossomComponent.shouldRender) {
      return null;
    }
    const children = blossomComponent.renderChildren(logger, l10n, context);

    return children.map((child) => <>{child}</>);
  }
}

export default AuthContainer;
